import { createContext } from "react";

const OrderContext = createContext();

export { OrderContext };